import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react"; // Optional: Use any icon lib

const Currency = ({ formData, setFormData }) => {
  const [isFocused, setIsFocused] = useState(false);
 const handleCurrencyChange = (event) => {
    const newCurrency = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      currency: newCurrency,
    }));
  };
  return (
    <div className="flex flex-col items-start justify-start w-full">
      <div className="flex flex-col justify-start">
        <h1 className="text-2xl font-semibold text-[#181D27] mb-1">Select your currency</h1>
        <p className="text-xl text-[#717680] mb-4">
          Select a default currency to track value
        </p>
      </div>

      <div className="relative w-2/5">
        <select
          className="w-full bg-[#F9F9F9] cursor-pointer appearance-none px-4 py-2 border border-[#D5D7DA] rounded-md text-sm focus:outline-none "
          defaultValue=""
          value={formData.currency || ""}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={handleCurrencyChange}

        >
          <option value="" disabled>Select currency</option>
          <option value="USD">USD - US Dollar</option>
          <option value="EUR">EUR - Euro</option>
          <option value="INR">INR - Indian Rupee</option>
        
        </select>

        <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
          {isFocused ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>
    </div>
  );
};

export default Currency;
